import { render, staticRenderFns } from "./import-bank-list.vue?vue&type=template&id=3d04d99d&"
import script from "./import-bank-list.vue?vue&type=script&lang=ts&"
export * from "./import-bank-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports